import React from 'react';
import './ServiceSingle.css';

import { Lightbox, PageTitle, SidebarHeading, Faqs } from '../../../components';
import { services } from '../../../constants';

import { FaCheck } from 'react-icons/fa';
import { GiSolarPower } from 'react-icons/gi';

import { Link, useLocation } from 'react-router-dom';



const ServiceSingle = () => {

  const location = useLocation();  
  const serviceSingle = location.state; 

  const features = serviceSingle.features;
  const process = serviceSingle.process;

  return (
    <>
      {/* Page Title */}
      <PageTitle title={serviceSingle.title} page={"Service Single"} />

      <section className='service-single page-single'>

        <div className='sidebar service-sidebar'>

          <div className='category sidebar-item'>

            <SidebarHeading title={'all services'} />

            <div className='box-container'>
              {services.map(service => {
                return  (
                /* Link to the individual service page */
                <Link
                  to={{
                    pathname: '/Services/' + service.title,
                  }}
                  location = {{service}}
                  state= {service}
                  key={service.id}
                  className='item'><span><div className='icon'><GiSolarPower /></div>{service.title}</span> {/* Service Title */}
                </Link> )
              })}
            </div>

            </div>

        </div>

        <div className='service-info page-info'>

          {/* Service Image */}
          <div className='image'>
            <img src={serviceSingle.image} alt={serviceSingle.title} />
          </div>

          <div className='content'>

            {/* Service heading */}
            <h3 className='main-heading'>{serviceSingle.title}</h3>

            {/* Service Content */}
            {serviceSingle.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

          </div>

          {/* Service Image gallery */}
          <Lightbox images={serviceSingle.gallery} />

          {/* Section for service benefits */}
          <div className='service-benefits sub-section'>

            <h3 className='sub-heading'>key features</h3>

            <p>Why choose our {serviceSingle.title} Service:</p>

            {/* List of service benefits */}
            <ul>
              {features.map((feature, index) => {
                return <li key={index}><FaCheck className='icon' />{feature}</li>
              })}
            </ul>

          </div>

          {/* Section for service process */}
          <div className='service-benefits sub-section'>

            <h3 className='sub-heading'>service process</h3>

            <p>How our {serviceSingle.title} Service works:</p>

            {/* List of service process steps */}
            <ul>
              {process.map((step, index) => {
                return <li key={index}><GiSolarPower className='icon' />{step}</li>
              })}
            </ul>

          </div>

          {/* Section for frequently asked questions */}
          <div className='service-faqs sub-section'>

            <h3 className='sub-heading'>frequently asked questions</h3>

            {/* Faq Accordion container */}
            <Faqs faqs={serviceSingle.faqs} />

          </div>
        
        </div> 

      </section> 
    </> 
  );
}

export default ServiceSingle;